import React from 'react';

const SkeletonProductCard = () => (
  <div className="bg-white rounded-lg shadow-md animate-pulse overflow-hidden">
    <div className="aspect-w-1 aspect-h-1 relative">
      <div className="w-full h-32 sm:h-40 md:h-48 bg-gray-200" />
    </div>
    <div className="p-2.5 sm:p-3 md:p-4">
      <div className="h-4 sm:h-5 bg-gray-200 rounded w-3/4 mb-2"></div>
      <div className="flex gap-2 items-center mb-2">
        <div className="h-3 w-12 sm:w-16 bg-gray-200 rounded" />
        <div className="h-3 w-8 bg-gray-100 rounded" />
      </div>
      <div className="h-5 sm:h-6 bg-gray-200 rounded mb-1 w-2/4"></div>
      <div className="flex space-x-2 mt-2">
        <div className="h-8 w-20 bg-gray-200 rounded" />
        <div className="h-8 w-8 bg-gray-100 rounded" />
        <div className="h-8 w-8 bg-gray-100 rounded" />
      </div>
    </div>
  </div>
);

export default SkeletonProductCard;
